module.exports = "/assets/data/45ae7fd494cf42275ff8ed2c6a05c941-CB6.data.json";